
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.946 5.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm1.5 3.5a1.5 1.5 0 00-3 0v8a1.5 1.5 0 001.5 1.5h4.5a.5.5 0 01.424.235l1.912 3.06a1.5 1.5 0 102.544-1.59l-1.912-3.06a3.48 3.48 0 00-2.968-1.645h-2.5a.5.5 0 01-.354-.146.5.5 0 01-.146-.354V9z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.578 20.609a6 6 0 01-4.767 2.877 6 6 0 01-6.262-4.892 6 6 0 014.085-6.816","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    